const env = require('/opt/build/repo/twing/environment.js');
let templatesModule = (() => {
let module = {
    exports: undefined
};

module.exports = (TwingTemplate) => {
    return new Map([
        [0, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = false;

                this.blocks = new Map([
                ]);
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`<div id="quotes">
  <div class="o-container--prose o-container">
    <div class="o-container__content o-rhythm u-pad-1">
      <h2>
        Pull Quote
      </h2>
      <p>
        A pull quote is a brief, attention-catching quotation, typically in a distinctive typeface, taken from the main text of an article and used as a subheading or graphic feature.
      </p>
      <div class="wp-block-pullquote has-background is-style-solid-color u-pull-inline-1">
        <blockquote>
          <p>
            Thinking is easy, acting is difficult, and to put one’s thoughts into action is the <em>most difficult</em> thing in the world.
          </p>
          <footer>
            <cite>
              Johann Wolfgang von Goethe
            </cite>
          </footer>
        </blockquote>
      </div>
      <h2>
        Block Quote
      </h2>
      <p>
        A block quotation is a quotation in a written document that is set off from the main text as a paragraph, or block of text, and typically distinguished visually using indentation and a different typeface or smaller size font.
      </p>
      <blockquote class="wp-block-quote">
        <p>
          The way of fortune is like the milky way in the sky; which is a number of small stars, not seen asunder, but giving light together: so it is a number of little and scarce discerned virtues, or rather faculties and customs, that make men fortunate.
        </p>
        <footer>
          <cite>
            Francis Bacon
          </cite>
        </footer>
      </blockquote>
      <p>
        Sometimes the <code>blockquote</code> element will appear in a comment when a reader wants to reference a specific piece of information.
      </p>
      `);
                this.echo(this.include(context, this.source, `@cloudfour/components/comment/comment.twig`, new Map([[`comment`, new Map([[`ID`, `5`], [`link`, `#comment-5`], [`date`, `2021-09-21T17:34:01.148Z`], [`avatar`, `https://placeimg.com/92/92/people`], [`author`, new Map([[`name`, `Buyap Narirido`]])], [`comment_content`, `<blockquote><p>Tipurur. Yihibux accessibility picture element decaqaz sketching wekadu.</p></blockquote><p>Thank you repository usability sufficient contrast polyfill nabubay dice decucu mockups project gapeba cubabepa IMHO design system. </p>`], [`is_child`, false], [`children`, new Map([[0, new Map([[`ID`, `6`], [`link`, `#comment-6`], [`date`, `2021-09-21T17:34:01.148Z`], [`avatar`, `https://placeimg.com/92/92/tech`], [`author`, new Map([[`name`, `Biko Bacupuyal`]])], [`comment_content`, `<p>Testing sticky notes web app thank you automate adaptive. Theming multidisciplinary project HTML cross-disciplinary responsive tumol web component this <a href="https://cloudfour.com/thinks/progressive-web-apps-simply-make-sense/">article</a> TL;DR.</p>`], [`is_child`, true], [`children`, new Map([])], [`approved`, true]])]])], [`approved`, true]])]]), false, false, 41));
                this.echo(`    </div>
  </div>
</div>

`);
            }

            getTemplateName() {
                return `1b1490249b22964e31b7dab9c6a0b5055adea342f60dcc461296a122655cf933`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `1b1490249b22964e31b7dab9c6a0b5055adea342f60dcc461296a122655cf933`, ``);
            }
        }],
    ]);
};

    return module.exports;
})();

env.registerTemplatesModule(templatesModule, '1b1490249b22964e31b7dab9c6a0b5055adea342f60dcc461296a122655cf933');

let template = env.loadTemplate('1b1490249b22964e31b7dab9c6a0b5055adea342f60dcc461296a122655cf933');

module.exports = (context = {}) => {
    const rendered = template.render(context);
     const inputs = window.__twig_inputs__ || (window.__twig_inputs__ = new Map());
     inputs.set(
       rendered,
       { path: "@cloudfour/prototypes/quotes/example/example.twig", args: context }
     );
     return rendered;;
};